module.exports = __webpack_public_path__ + "static/media/AS_icon_person.427ba250.svg";